module.exports = __webpack_public_path__ + "img/Pending.53fdbfa9.svg";